import { footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-smile-2-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-bold text-background-50 font-heading">吃瓜51</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              吃瓜51网是国内领先的娱乐八卦与热门事件聚合平台，提供最新吃瓜爆料与热门事件入口，汇集全网实时八卦、网红黑料、51独家爆料内容，每天更新热门吃瓜资讯。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4 font-heading">快速导航</h3>
            <ul className="space-y-2">
              {footerLinks.slice(0, 4).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4 font-heading">法律信息</h3>
            <ul className="space-y-2">
              {footerLinks.slice(4).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4 font-heading">合作伙伴</h3>
            <div className="grid grid-cols-3 gap-2">
              {Array.from({ length: 6 }).map((_, i) => (
                <div
                  key={i}
                  className="h-10 bg-background-50/10 rounded flex items-center justify-center text-xs text-background-50/30"
                >
                  合作品牌
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 吃瓜51网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}